(function (window, $) {
    'use strict';

    const checkoutModules = window.TlpCheckoutModules = window.TlpCheckoutModules || {};
    const eventNamespace = 'lpCheckoutSteps';
    const paymentLockedMessage = 'Please complete your billing information before adding a payment method.';

    checkoutModules.steps = {
        selectors: {
            step: '[data-lp-checkout-step]',
            stepTab: '[data-lp-checkout-open]',
            stepBodyAttr: 'data-lp-checkout-body',
            billingStep: '[data-lp-checkout-step="billing"]',
            paymentStep: '[data-lp-checkout-step="payment"]',
            invalidRow: '.woocommerce-invalid, .woocommerce-invalid-required-field',
            requiredRow: '.validate-required',
            field: 'input:not([type="hidden"]), select, textarea',
            nextButton: '.js-lp-go-to-payment'
        },

        currentStep: 'billing',
        paymentUnlocked: false,
        skipPaymentLock: false,

        init() {
            this.$checkout = $('.lp-checkout');
            if (!this.$checkout.length) {
                return;
            }

            this.currentStep = 'billing';
            this.skipPaymentLock = $('body').hasClass('role-user');
            this.paymentUnlocked = this.skipPaymentLock;

            this.bindEvents();
            this.syncPaymentLockUI();
            this.syncNextButtonUI();
            this.setStep('billing', { scroll: false });
        },

        bindEvents() {
            const selectors = this.selectors;

            this.$checkout
                .off(`.${eventNamespace}`)
                .on(
                    `input.${eventNamespace} change.${eventNamespace}`,
                    `${selectors.billingStep} input, ${selectors.billingStep} select, ${selectors.billingStep} textarea`,
                    () => {
                        this.relockPaymentStepIfInvalid();
                        this.syncNextButtonUI();
                    }
                )
                .on(`click.${eventNamespace}`, selectors.stepTab, (e) => {
                    const step = $(e.currentTarget).attr('data-lp-checkout-open');
                    if (!step) {
                        return;
                    }

                    if (this.currentStep === step) {
                        this.setStep('', { scroll: false });
                        return;
                    }

                    if (step === 'payment' && !this.paymentUnlocked && !this.skipPaymentLock) {
                        if (!this.validateBillingStep()) {
                            return;
                        }

                        this.paymentUnlocked = true;
                        this.syncPaymentLockUI();
                    }

                    this.setStep(step, { scroll: true });
                })
                .on(`click.${eventNamespace}`, selectors.nextButton, (e) => {
                    this.syncNextButtonUI();
                    if ($(e.currentTarget).is(':disabled')) {
                        return;
                    }

                    if (!this.validateBillingStep()) {
                        return;
                    }

                    this.paymentUnlocked = true;
                    this.syncPaymentLockUI();
                    this.setStep('payment', { scroll: true });
                    $(document.body).trigger('update_checkout');
                });

            $(document.body)
                .off(`updated_checkout.${eventNamespace}`)
                .on(`updated_checkout.${eventNamespace}`, () => {
                    this.relockPaymentStepIfInvalid({
                        redirectToBilling: this.currentStep === 'payment',
                        focusInvalid: false,
                        scroll: false
                    });
                    this.setStep(this.currentStep, { scroll: false });
                    this.syncNextButtonUI();
                    this.syncPaymentLockUI();
                })
                .off(`checkout_error.${eventNamespace}`)
                .on(`checkout_error.${eventNamespace}`, () => {
                    this.relockPaymentStepIfInvalid({
                        redirectToBilling: true
                    });
                });
        },

        getStep(name) {
            return this.$checkout.find(`${this.selectors.step}[data-lp-checkout-step="${name}"]`);
        },

        getBillingStep() {
            return this.$checkout.find(this.selectors.billingStep);
        },

        getNextButtons() {
            return this.$checkout.find(this.selectors.nextButton);
        },

        getRowField($row) {
            return $row.find(this.selectors.field).filter(':enabled').first();
        },

        rowIsComplete($row) {
            if (!$row.length) {
                return true;
            }

            const $billingBody = $row.closest(`[${this.selectors.stepBodyAttr}="billing"]`);
            const isHiddenByCollapsedBillingStep = $billingBody.length && $billingBody.prop('hidden');

            if (!$row.is(':visible') && !isHiddenByCollapsedBillingStep) {
                return true;
            }

            const $field = this.getRowField($row);
            if (!$field.length) {
                return true;
            }

            const type = String($field.attr('type') || '').toLowerCase();
            if (type === 'checkbox' || type === 'radio') {
                return $row.find(`input[type="${type}"]`).is(':checked');
            }

            const value = $field.val();
            return !(value === null || typeof value === 'undefined' || String(value).trim() === '');
        },

        findFirstInvalidBillingField() {
            const $billing = this.getBillingStep();
            if (!$billing.length) {
                return null;
            }

            let $invalid = null;

            $billing.find(this.selectors.invalidRow).each((index, element) => {
                if ($invalid) {
                    return;
                }

                const $row = $(element);
                const $field = this.getRowField($row);
                if ($field.length) {
                    $invalid = $field;
                }
            });

            if ($invalid) {
                return $invalid;
            }

            $billing.find(this.selectors.requiredRow).each((index, element) => {
                if ($invalid) {
                    return;
                }

                const $row = $(element);
                if (!this.rowIsComplete($row)) {
                    $invalid = this.getRowField($row);
                }
            });

            return $invalid;
        },

        relockPaymentStepIfInvalid(opts = {}) {
            if (this.skipPaymentLock) {
                return false;
            }

            const $invalid = this.findFirstInvalidBillingField();
            if (!$invalid || !$invalid.length) {
                return false;
            }

            this.paymentUnlocked = false;
            this.syncPaymentLockUI();

            if (opts.redirectToBilling && this.currentStep === 'payment') {
                this.setStep('billing', { scroll: opts.scroll !== false });

                if (opts.focusInvalid !== false) {
                    this.focusField($invalid);
                }
            }

            return true;
        },

        syncPaymentLockUI() {
            const $payment = this.$checkout.find(this.selectors.paymentStep);
            const isLocked = !this.paymentUnlocked && !this.skipPaymentLock;

            $payment.toggleClass('lp-checkout-step--locked', isLocked);
            $payment.attr('data-tooltip', isLocked ? paymentLockedMessage : '');
            $payment
                .find('[data-lp-checkout-open="payment"]')
                .attr('aria-disabled', isLocked ? 'true' : 'false');
        },

        syncNextButtonUI() {
            const $buttons = this.getNextButtons();
            if (!$buttons.length) {
                return;
            }

            const enabled = !this.findFirstInvalidBillingField();
            $buttons.prop('disabled', !enabled);
            $buttons.toggleClass('disabled', !enabled);
            $buttons.attr('aria-disabled', enabled ? 'false' : 'true');
        },

        setStep(step, opts = {}) {
            this.currentStep = step;

            this.$checkout.find(this.selectors.step).each((index, element) => {
                const $step = $(element);
                const stepName = $step.attr('data-lp-checkout-step');
                const isOpen = stepName === step;

                $step.toggleClass('is-open', isOpen);
                $step
                    .find(this.selectors.stepTab)
                    .attr('aria-expanded', isOpen ? 'true' : 'false');

                const $body = $step.find(`[${this.selectors.stepBodyAttr}="${stepName}"]`);
                if ($body.length) {
                    $body.prop('hidden', !isOpen);
                }
            });

            if (opts.scroll !== false) {
                const $target = this.getStep(step);
                if ($target.length) {
                    $('html, body').animate({ scrollTop: $target.offset().top - 20 }, 250);
                }
            }
        },

        focusField($field) {
            if (!$field || !$field.length) {
                return;
            }

            const $row = $field.closest('.form-row');
            const $select2 = $row.find('.select2-selection');
            if ($select2.length) {
                $select2.trigger('focus');
                return;
            }

            $field.trigger('focus');
        },

        validateBillingStep() {
            const $invalid = this.findFirstInvalidBillingField();
            if (!$invalid || !$invalid.length) {
                return true;
            }

            this.setStep('billing', { scroll: true });
            this.focusField($invalid);
            return false;
        }
    };
})(window, jQuery);
